import React from 'react';
import { CinematicHero } from './CinematicHero';
export function Hero() {
  return <CinematicHero data-id="element-235" data-mp="7wrp379njdqr" />;
}